import {
  Checkbox,
  FormControl,
  FormControlProps,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export type WsSelectCheckBoxOptions = {
  label: string;
  value: string;
};

interface WsSelectCheckBoxProps extends FormControlProps {
  name: string;
  options: WsSelectCheckBoxOptions[];
  disabled?: boolean;
  placeholder?: string;
}

const ITEM_HEIGHT = 38;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const WsSelectCheckBox = ({
  name,
  options,
  disabled = false,
  placeholder,
  ...formControlProps
}: WsSelectCheckBoxProps) => {
  const { control } = useFormContext();

  return (
    <FormControl disabled={disabled} {...formControlProps}>
      {placeholder && <InputLabel id={`${name}-label`}>{placeholder}</InputLabel>}
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <Select
              labelId={`${name}-label`}
              id={`${name}-select`}
              multiple
              sx={{
                minHeight: 40,
                fontSize: 14,
              }}
              {...field}
              renderValue={(selected) =>
                (selected as string[])
                  .map((val) => options.find((opt) => opt.value === val)?.label || val)
                  .join(', ')
              }
              MenuProps={MenuProps}
            >
              {options.map((option: WsSelectCheckBoxOptions, index) => (
                <MenuItem key={index} value={option.value}>
                  <Checkbox size="small" checked={field?.value?.includes(option.value) ?? false} />
                  <ListItemText primary={option.label} sx={{ fontSize: 14 }} />
                </MenuItem>
              ))}
            </Select>
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </FormControl>
  );
};

export default WsSelectCheckBox;
